import { inject, Injectable } from "@angular/core";
import { DateTime, Settings } from "luxon";
import { Adapter } from "src/app/core/adapter";
import { Model } from "src/app/core/models/model";
import { GraphElementDto } from "src/app/shared/components/graph/dto/graph-element-dto";
import { Shower, ShowerAdapter } from "./shower.model";

export class ShowerheadSignalElement implements Model, GraphElementDto {
  public get xLabel(): String {
    return this.date.toISO();
  }
  public get barValue(): number {
    return this.volume;
  }
  public get lineValue(): number {
    return this.temperature ? Math.round(this.temperature * 10) / 10 : null;
  }

  public bar2Value: number = null;
  public line2Value: number = null;

  public barStyle: string = null;

  public static GetEmptySignalElement(date: DateTime) {
    return new ShowerheadSignalElement(date, 0, 0, 0, 0, 0, 0, false, null);
  }

  constructor(
    public date: DateTime,
    public duration: number,
    public volume: number,
    public flow: number,
    public temperature: number,
    public countByDay: number,
    public count: number,
    public withLive: boolean,
    public shower: Shower
  ) {}
}

export type ShowerheadSignalsMap = { [key: string]: ShowerheadSignalElement[] };

@Injectable({
  providedIn: "root",
})
export class ShowerheadSignalAdapter
  implements Adapter<ShowerheadSignalElement>
{
  private showerAdapter: ShowerAdapter = inject(ShowerAdapter);

  constructor() {}

  adapt(item: any): ShowerheadSignalElement {
    return new ShowerheadSignalElement(
      DateTime.fromISO(item.date, { zone: Settings.defaultZone }),
      item.duration,
      item.volume,
      item.flow,
      item.temperature,
      item.countByDay,
      item.count,
      item.withLive,
      item.count === 1 && item.shower
        ? this.showerAdapter.adapt(item.shower)
        : null
    );
  }
}
